<template>
  <div class="logo" :class="{ dark: variant == 'dark' }">
    <strong> КШДУ </strong>
    <span>ім. Сергія Нижного</span>
  </div>
</template>

<script>
export default {
  props: ["variant"],
};
</script>

<style lang="scss" scoped>
.logo {
  line-height: 1;
  text-decoration: none !important;
  strong {
    font-weight: 400;
    letter-spacing: 3px;
    font-size: 36px;
    display: block;
  }
  span {
    font-size: 12px;
  }
  color: #fff;
  &.dark {
    color: var(--primary-color);
  }
}
</style>
